
export default function TechnologySection() {
  const technologyServices = [
    {
      title: '3D Property Scans',
      image: 'https://public.readdy.ai/ai/img_res/421800427923b776b2638cb6f0d7e383.jpg'
    },
    {
      title: 'Digital Floor & Site Mapping',
      image: 'https://readdy.ai/api/search-image?query=Digital%20floor%20plan%20and%20site%20mapping%20displayed%20on%20tablet%20device%20showing%20detailed%20architectural%20blueprints%20with%20measurements%20and%20room%20layouts%20professional%20property%20documentation%20technology%20clean%20light%20blue%20background&width=400&height=300&seq=tech2&orientation=landscape'
    },
    {
      title: 'Remote Architectural Review',
      image: 'https://readdy.ai/api/search-image?query=Professional%20architect%20reviewing%20building%20plans%20on%20computer%20screen%20remote%20architectural%20analysis%20with%20digital%20blueprints%20and%20property%20documentation%20modern%20office%20setting%20business%20professional%20at%20work&width=400&height=300&seq=tech3&orientation=landscape'
    },
    {
      title: 'Engineering Coordination',
      image: 'https://readdy.ai/api/search-image?query=Architectural%20engineering%20coordination%20with%20detailed%20house%20blueprint%20drawings%20showing%20structural%20elements%20and%20construction%20plans%20professional%20technical%20documentation%20light%20blue%20background%20with%20pencil%20and%20drafting%20tools&width=400&height=300&seq=tech4&orientation=landscape'
    },
    {
      title: 'Pre Construction & Retrofit Planning',
      image: 'https://readdy.ai/api/search-image?query=Pre-construction%20planning%20and%20retrofit%20design%20with%20architectural%20model%20house%20on%20blueprints%20showing%20renovation%20and%20improvement%20plans%20professional%20construction%20consulting%20documentation%20light%20blue%20technical%20background&width=400&height=300&seq=tech5&orientation=landscape'
    },
    {
      title: 'Storm & Risk Preparedness Analysis',
      image: 'https://readdy.ai/api/search-image?query=Storm%20preparedness%20and%20risk%20analysis%20professional%20reviewing%20weather%20radar%20and%20hurricane%20tracking%20data%20on%20multiple%20screens%20emergency%20planning%20and%20property%20protection%20technology%20modern%20monitoring%20station&width=400&height=300&seq=tech6&orientation=landscape'
    }
  ];

  const capabilities = [
    'We coordinate scans',
    'We interpret findings',
    'We collaborate with architects & engineers',
    'We translate data into clear action plans'
  ];

  const propertyTypes = [
    { icon: 'ri-school-line', label: 'Schools & Campuses' },
    { icon: 'ri-building-2-line', label: 'Commercial Properties' },
    { icon: 'ri-community-line', label: 'Multi-Family & HOA Communities' },
    { icon: 'ri-home-8-line', label: 'Large Residential Estates' },
    { icon: 'ri-file-damage-line', label: 'Post-Event Documentation' }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-slate-100 to-slate-200">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6">
            Advanced Site Intelligence & Technology Partners
          </h2>
          <p className="text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed">
            SafePoint Solutions partners with advanced technology providers to deliver high-resolution <strong>3D site imagery</strong>, <strong>structural mapping</strong>, and <strong>digital documentation</strong>. These tools allow our team — along with architectural and engineering partners to analyze properties with greater accuracy, efficiency, and foresight.
          </p>
        </div>

        {/* Technology Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {technologyServices.map((service, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 bg-white"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-slate-900/90 via-slate-900/60 to-transparent p-6">
                <h3 className="text-white font-bold text-lg">{service.title}</h3>
              </div>
            </div>
          ))}
        </div>

        {/* Key Message */}
        <div className="bg-white rounded-2xl shadow-xl p-10 mb-16">
          <h3 className="text-2xl md:text-3xl font-bold text-slate-800 text-center mb-10">
            SAFEPOINT DOES NOT SELL <span className="text-teal-600">TECHNOLOGY</span>. WE INTERPRET IT.
          </h3>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Capabilities */}
            <div>
              <ul className="space-y-4">
                {capabilities.map((capability, index) => (
                  <li key={index} className="flex items-start gap-4">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-teal-600 text-xl"></i>
                    </div>
                    <span className="text-gray-700 text-lg">
                      {capability.includes('clear action plans') ? (
                        <>We translate data into <span className="text-teal-600 font-semibold">clear action plans</span></>
                      ) : (
                        capability
                      )}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Property Types */}
            <div>
              <ul className="space-y-4">
                {propertyTypes.map((type, index) => (
                  <li key={index} className="flex items-center gap-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-slate-100 rounded-lg">
                      <i className={`${type.icon} text-slate-700 text-xl`}></i>
                    </div>
                    <span className="text-gray-700 text-lg">{type.label}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Tagline */}
        <div className="text-center">
          <div className="text-2xl md:text-3xl font-bold italic text-teal-600 mb-3">
            Professional. Accurate. Actionable.
          </div>
          <p className="text-lg text-gray-600">
            Site intelligence that supports better decisions.
          </p>
        </div>
      </div>
    </section>
  );
}
